import React from 'react';
import { Link } from 'react-router-dom';
import { hasRoleAccess } from '../utils/roles'; // Import role-checking helper
import './Navbar.css';

const Navbar = ({ isOpen, toggleMenu, handleLogout, userRole }) => {
  console.log("User Role in Navbar:", userRole);

  return (
    <nav className="navbar">
      <ul className={`nav-links ${isOpen ? 'open' : ''} ${hasRoleAccess(userRole, 'admin-tools') ? 'admin-view' : ''}`}>
        <li>
          <Link to="/" onClick={toggleMenu}>
            Home
          </Link>
        </li>
        <li>
          <Link to="/shipping" onClick={toggleMenu}>
            Shipping
          </Link>
        </li>
        {/* Only show Calibration link for users with 'calibration' permission and role === 'Dev' */}
        {hasRoleAccess(userRole, 'calibration-read') && (
          <li>
            <Link to="/calibration" onClick={toggleMenu}>
              Calibration
            </Link>
          </li>
        )}
        <li>
          <Link to="/pnl" onClick={toggleMenu}>
            Project Number Lookup
          </Link>
        </li>
        {/* Only show Admin Tools if the user has the required permission */}
        {hasRoleAccess(userRole, 'admin-tools') && (
          <li>
            <Link to="/admin-tools" onClick={toggleMenu}>
              Admin Tools
            </Link>
          </li>
        )}
        <li className="logout">
          <button onClick={handleLogout}>Logout</button>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
